import React from 'react';
import {
  reduxForm,
  Field,
  Form,
  formValueSelector,
  InjectedFormProps,
} from 'redux-form';
import { compose } from 'ramda';
import Grid from '@material-ui/core/Grid';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/Button/Button';
import Fields from 'components/Fields';
import { useFormatMessage } from 'components/IntlProvider';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { RouteComponentProps } from 'react-router-dom';

const { connect } = StoreProvider;
const { withRouter } = RouterProvider;

interface RespondentsProps extends InjectedFormProps {
  initialValues: {
    rows: any;
  };
  sendToAll: boolean;
  children: any;
}

const useStyles = makeStyles({
  fieldsBox: {
    display: 'flex',
    alignItems: 'center',
  },
  btn: {
    marginTop: '2rem',
  },
});

const RespondentsList = ({
  sendToAll,
  handleSubmit,
  initialValues,
  children,
  submitting,
  match,
  history,
}: RespondentsProps & RouteComponentProps<any>) => {
  const t = useFormatMessage();
  const classes = useStyles();
  const { results } = initialValues.rows;
  const { id } = match.params;

  return (
    <Form onSubmit={handleSubmit}>
      <Grid item>
        <Field
          variant="outlined"
          margin="normal"
          name="sendToAll"
          component={Fields.Checkbox}
          label="Send to All"
        />
      </Grid>

      {sendToAll
        ? null
        : results.map(function ({
            respondent,
            id,
            uuid,
          }: {
            respondent: any;
            id: number;
            uuid: string;
          }) {
            return (
              <Grid item key={id}>
                <Field
                  variant="outlined"
                  margin="normal"
                  name={`respondents.${uuid}`}
                  component={Fields.Checkbox}
                  label={respondent.email}
                ></Field>
              </Grid>
            );
          })}
      <Grid item xs={2}>
        {!sendToAll && children}
      </Grid>
      <Grid container spacing={1} className={classes.btn}>
        <Grid item>
          <Button
            isLoading={submitting}
            type="submit"
            variant="contained"
            color="primary"
          >
            {sendToAll
              ? t('dashboard.respondendts.sendToAll', 'Send to all')
              : t('dashboard.respondendts.send', 'Send')}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push(`/project/${id}/surveys`)}
          >
            {t('pages.project.modal.cancel', 'Cancel')}
          </Button>
        </Grid>
      </Grid>
    </Form>
  );
};

const selector = formValueSelector('respondentsList');
export default compose(
  connect((state: any) => ({
    sendToAll: selector(state, 'sendToAll'),
  })),
  withRouter,
  reduxForm({
    form: 'respondentsList',
  })
)(RespondentsList);
